import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import StepTwoForm from './form';
import style from '../styles/style.module.css';

class StepTwo extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className={ `${ style.stepTwo } ${ style.listCreationStep }` }>
                <div className={ style.titleBar }>
                    <h2>Tell us more about your List</h2>
                </div>
                <div className={ style.stepContent }>
                    <StepTwoForm onSubmit={ this.props.onSubmit } />
                </div>
            </div>
        );
    }
}
StepTwo.defaultProps = {
    onSubmit: ()=>{},
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        ownLists: state.self.lists,
    };
};

export default connect( mapStateToProps )( StepTwo );
